import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconAudioPrevComponent } from "./med-icon-audio-prev.component";

@NgModule({
  declarations: [
    MedIconAudioPrevComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconAudioPrevComponent,
  ],
})
export class MedIconAudioPrevModule { }
